<!--
 * @Author: Src
 * @Date: 2025-08-08 13:36:31
 * @LastEditTime: 2025-08-14 20:43:15
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/car/detaile.vue
 * @Description: 头部注释配置模板
-->
<template>
    <div class="car_detaile" v-loading="loading">
        <div>
            <el-carousel :interval="5000" arrow="never" trigger="hover">
                <el-carousel-item v-for="(item, index) in shopImg" :key="index">
                    <img :src="item" style="width: 100%;" />
                </el-carousel-item>
            </el-carousel>
        </div>
        <div>
            <div class="top_class">
                <div class="_price"><span>{{ commodity.price }} </span>万元</div>
                <div class="price_info">
                    新车指导价{{ model.official_price }}万元,购置税 {{ model.tax }} 万元, 共省{{ getPrice() }}万元
                </div>
            </div>
            <div class="car_body">
                <div class="car_name"> {{ commodity.name }}</div>
                <div class="car_tag_box">
                    <span class="car_tag" v-for="(res, index) in commodity.tags" :key="index">{{ res }}</span>
                </div>
            </div>
            <div class="car_body">
                <div class="car_title">
                    车辆信息
                </div>
                <div :class="carShow ? 'car_list' : ' car_list car_list_box'">
                    <div class="car_card"><span class="card_left">首次上牌</span><span class="card_right">{{
                        commodity.first_registration_date }}</span></div>
                    <div class="car_card"><span class="card_left">上市时间</span><span class="card_right">{{
                        model.market_date }}</span></div>
                    <div class="car_card"><span class="card_left">表显里程</span><span class="card_right">{{
                        `${commodity.mileage}万公里` }}</span></div>
                    <div class="car_card" v-if="!carType"><span class="card_left">续航里程</span><span class="card_right">{{
                        `${model.battery_max_miles}公里` }}</span></div>
                    <div class="car_card"><span class="card_left">过户次数</span><span class="card_right">{{
                        commodity.transfer_times }}</span></div>
                    <div class="car_card"><span class="card_left">车辆性质</span><span class="card_right">{{
                        commodity.use_to }}</span></div>
                    <div class="car_card"><span class="card_left">车身颜色</span><span class="card_right">{{
                        commodity.color }}</span></div>
                    <div class="car_card"><span class="card_left">长*宽*高(mm)</span><span class="card_right">{{
                        `${model.car_length}*${model.car_width}*${model.car_height}` }}</span></div>
                    <div class="car_card"><span class="card_left">车重</span><span class="card_right">{{
                        `${model.car_weight}kg` }}</span></div>
                    <div class="car_card"><span class="card_left">车辆级别</span><span class="card_right">{{
                        model.category }}</span></div>
                    <div class="car_card" v-if="!carType"><span class="card_left">电池类型</span><span class="card_right">{{
                        model.battery_type }}</span></div>
                    <div class="car_card" v-if="!carType"><span class="card_left">电池容量</span><span class="card_right">{{
                        model.rear_tire_spec }}</span></div>


                    <div class="car_card"  v-if="carType"><span class="card_left">排放标准</span><span class="card_right">{{
                        model.discharge_standard }}</span></div>

                    <div class="car_card" v-if="carType"><span class="card_left">燃油类型</span><span class="card_right">{{
                        model.roz }}</span></div>
                        


                    <div class="car_card"><span class="card_left">车检日期</span><span class="card_right">{{
                        commodity.commercial_insurance_date || '--' }}</span></div>


                    <div class="car_card"><span class="card_left">交强险到期</span><span class="card_right">{{
                        commodity.traffic_insurance_date || '--' }}</span></div>
                    <div class="car_card car_cardflex"><span class="card_left">所在地区</span><span class="card_right">{{
                        commodity.car_location }}</span></div>


                </div>
                <div class="car_more">
                    <span @click="changeShow">
                        {{ carShow ? '收起更多' : '展开更多' }}
                    </span>
                </div>
            </div>
            <div class="car_body">
                <div class="car_title">
                    功能配置
                </div>
                <div class="car_list">
                    <div class="car_card" v-if="!carType"><span class="card_left">电动机</span><span class="card_right">{{
                        model.torque }}</span></div>
                    <div class="car_card" v-if="carType"><span class="card_left">进气方式</span><span class="card_right">{{
                        model.intake }}</span></div>
                    <div class="car_card"><span class="card_left">变速箱类型</span><span class="card_right">{{
                        model.gear_name }}</span></div>
                    <div class="car_card"><span class="card_left">驱动方式</span><span class="card_right">{{
                        model.drive_name }}</span></div>
                    <div class="car_card"><span class="card_left">能源类型</span><span class="card_right">{{
                        model.discharge_standard }}</span></div>
                    <div class="car_card"><span class="card_left">座位数</span><span class="card_right">{{
                        model.seat_number }}</span></div>
                    <div class="car_card"><span class="card_left">级别</span><span class="card_right">{{
                        model.category }}</span></div>

                </div>
            </div>
            <div class="car_body">
                <div class="car_title">
                    亮点
                </div>
                <div class="car_list">
                    <div v-for="(res) in commodity.highlights" :key="res" class="car_highli">
                        <img :src="highlights[res - 1].icon" class="car_highli_icon" />
                        <span class="car_span">{{ highlights[res - 1].name }}</span>
                    </div>
                </div>
            </div>
            <div class="car_body">
                <div class="car_title">
                    车况描述
                </div>
                <div class="car_text">
                    {{ commodity.description }}
                </div>
            </div>
            <div class="car_body">
                <div class="car_title">
                    图片
                </div>
                <div class="car_img">
                    <img :src="commodity.header_image" style="width: 100%;" />
                    <img v-for="(item, index) in commodity.car_images" :src="item" style="width: 100%;" :key="index" />
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
import { Vue, Component } from 'vue-property-decorator';
import lazyInject from '@/di';
import CarService from '@/services/car.service';
import icon1 from '@/assets/icon/1.png';
import icon2 from '@/assets/icon/2.png';
import icon3 from '@/assets/icon/3.png';
import icon4 from '@/assets/icon/4.png';
import icon5 from '@/assets/icon/5.png';
import icon6 from '@/assets/icon/6.png';
import icon7 from '@/assets/icon/7.png';
import icon8 from '@/assets/icon/8.png';
import icon9 from '@/assets/icon/9.png';
import icon10 from '@/assets/icon/10.png';
import icon11 from '@/assets/icon/11.png';
import icon12 from '@/assets/icon/12.png';
import icon13 from '@/assets/icon/13.png';
import icon14 from '@/assets/icon/14.png';
import icon15 from '@/assets/icon/15.png';
import icon16 from '@/assets/icon/16.png';
import icon17 from '@/assets/icon/17.png';
import icon18 from '@/assets/icon/18.png';
import icon19 from '@/assets/icon/19.png';
import icon20 from '@/assets/icon/20.png';
import icon21 from '@/assets/icon/21.png';
import icon22 from '@/assets/icon/22.png';
import icon23 from '@/assets/icon/23.png';
import icon24 from '@/assets/icon/24.png';
import icon25 from '@/assets/icon/25.png';
import icon26 from '@/assets/icon/26.png';
import icon27 from '@/assets/icon/27.png';
import icon28 from '@/assets/icon/28.png';
import icon29 from '@/assets/icon/29.png';
import icon30 from '@/assets/icon/30.png';
import icon31 from '@/assets/icon/31.png';
import icon32 from '@/assets/icon/32.png';
import icon33 from '@/assets/icon/33.png';
import icon34 from '@/assets/icon/34.png';
import icon35 from '@/assets/icon/35.png';
import icon36 from '@/assets/icon/36.png';
import icon37 from '@/assets/icon/37.png';
import icon38 from '@/assets/icon/38.png';
import icon39 from '@/assets/icon/39.png';
import icon40 from '@/assets/icon/40.png';



@Component({})
export default class CarDetail extends Vue {
    @lazyInject(CarService)
    protected carService!: CarService;

    commodity: any = {};

    model: any = {};

    highlights = [
        { name: '胎压监测装置', icon: icon1, },
        { name: '并线辅助', icon: icon2, },
        { name: '车道保持辅助系统', icon: icon3 },
        { name: '车道偏离预警系统', icon: icon4 },
        { name: '主动刹车/主动安全系统', icon: icon5 },
        { name: 'ISOFIX儿童座椅接口', icon: icon6 },
        { name: '倒车影像', icon: icon7 },
        { name: '全景摄像头', icon: icon8 },
        { name: '自动驻车', icon: icon9 },
        { name: '自动泊车入位', icon: icon10 },
        { name: '定速巡航', icon: icon11 },
        { name: '中央 差速器锁止', icon: icon12 },
        { name: '电动后备厢', icon: icon13 },
        { name: '感应后备厢', icon: icon14 },
        { name: '无钥匙启动系统', icon: icon15 },
        { name: '无钥匙进入系统', icon: icon16 },
        { name: '电动吸合门', icon: icon17 },
        { name: '主动闭合式进气格栅', icon: icon18 },
        { name: '方向盘换挡', icon: icon19 },
        { name: '方向盘加热', icon: icon20 },
        { name: '全液晶仪表盘', icon: icon21 },
        { name: '手机无线充电', icon: icon22 },
        { name: 'HUD抬头数字显示', icon: icon23 },
        { name: '内置行车记录仪', icon: icon24 },
        { name: '蓝牙/车载电话', icon: icon25 },
        { name: '手机互联/映射', icon: icon26 },
        { name: '车联网', icon: icon27 },
        { name: '220V/230V电源', icon: icon28 },
        { name: 'OTA升级', icon: icon29 },
        { name: '转向辅助灯', icon: icon30 },
        { name: '转向头灯', icon: icon31 },
        { name: '自适应远近光', icon: icon32 },
        { name: '车内氛围灯', icon: icon33 },
        { name: '防紫外线玻璃', icon: icon34 },
        { name: '电动侧滑门', icon: icon35 },
        { name: '车内PM2.5过滤装置', icon: icon36 },
        { name: '车载空气净化器', icon: icon37 },
        { name: '后排独立空调', icon: icon38 },
        { name: '后排出风口', icon: icon39 },
        { name: '自适应巡航', icon: icon40 },

    ]

    shopImg: any = [];

    carShow = false;

    carType = false; // false 代表纯电车

    loading = true;

    "car_images" = [

        "http://deyouhui.oss-cn-shanghai.aliyuncs.com/20250806184528767_3483/pSvhf0GmY0nwH7LcS8bBRsDTBm7a4UHck0E0rnje.png?Expires=1759816223&OSSAccessKeyId=LTAI5tFD4RJ5wUR41ARLr27j&Signature=gKVftf%2B1aTYRGW4jWAeOyw3PiiA%3D",

        "http://deyouhui.oss-cn-shanghai.aliyuncs.com/20250805181744762_3483/7QsjNOeX5hEmWlw34ZGRsf4lBrO2THw33WjiuwlW.png?Expires=1759816223&OSSAccessKeyId=LTAI5tFD4RJ5wUR41ARLr27j&Signature=bcqx3znf2JL9OSau7PJMOhSDZ0Y%3D",

        "http://deyouhui.oss-cn-shanghai.aliyuncs.com/20250807103755625_3483/IQmFNvzNxu2V8LTKKiY7hA4JvHsJg0VwWEaL9abo.png?Expires=1759816223&OSSAccessKeyId=LTAI5tFD4RJ5wUR41ARLr27j&Signature=bVvCXQii8k2vqahVrK7zACR8N2s%3D",

        "http://deyouhui.oss-cn-shanghai.aliyuncs.com/20250807165216962_3483/b4ofvTYH3huF0bX5qqRW0fcWCre2Kp4Y0uXW3HUB.png?Expires=1759816223&OSSAccessKeyId=LTAI5tFD4RJ5wUR41ARLr27j&Signature=8B806HPDiA5MEBLZIpB9%2BsnrIpU%3D",

    ];

    changeShow() {
        this.carShow = !this.carShow
    }


    getPrice() {
        const price = (this.model.official_price ? Number(this.model.official_price) : 0) + (this.model.tax ? Number(this.model.tax) : 0) - Number(this.commodity.price)
        return price.toFixed(2)
    }

    async getCarDetail(code: any) {
        const res = await this.carService.getCarDetail(code);
        if (res) {
            const { commodity, model } = res;
            this.model = model
            this.commodity = commodity
            let shopImg: any = []
            shopImg[0] = commodity.header_image
            shopImg = [...this.shopImg, ...commodity.car_images];
            this.shopImg = shopImg.slice(0, 5);
            if (model.discharge_standard.includes('纯电')) {
                this.carType = false; //纯电
            } else {
                this.carType = true; // 混动 油车
            }
            this.loading = false;
        }
    }

    async mounted() {
        const { id } = this.$route.params;
        await this.getCarDetail(id);
    }
}
</script>
<style scoped lang="scss">
.car_detaile {
    background: #f8f8f8;

    // height: 100vh;
    .top_class {
        margin: 10px;
        padding: 10px;

        ._price {
            font-size: 14px;
            color: #ea553f;

            span {
                font-size: 24px;
                font-weight: bold;

            }
        }

        .price_info {
            margin-top: 20px;
            font-size: 12px;
            color: #67676e;
        }
    }

    .car_body {
        margin: 10px;
        padding: 20px 10px;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
        border-radius: 10px;

        .car_title {
            font-size: 18px;
            font-weight: bold;
            margin-bottom: 20px;
        }

        .car_tag_box {
            margin-top: 20px;

            .car_tag {
                color: #67676e;
                box-sizing: border-box;
                background: #f4f5f8;
            }

        }

        .car_name {
            font-size: 18px;
            font-weight: bold;
        }

        .car_text {
            white-space: pre-line;
        }

        .car_list {
            display: flex;
            flex-wrap: wrap;


            .car_card {
                width: 50%;
                margin-bottom: 10px;

                .card_left {
                    color: #a0a0a7;
                    font-size: 13px !important;

                }

                .card_right {
                    padding: 5px 10px;
                    font-size: 13px !important;
                    color: #23242e;
                }
            }

            .car_cardflex {
                width: 100% !important;
            }

            .car_highli {
                width: 25%;
                padding: 5px;
                box-sizing: border-box;
                font-size: 12px !important;
                display: flex;
                flex-direction: column;
                align-items: center;

                .car_highli_icon {
                    width: 40px;
                }

                .car_span {
                    text-align: center;
                    font-size: 12px !important;
                }
            }

        }

        .car_list_box {
            width: 100%;
            height: 140px;
            overflow: hidden;
        }

        .car_more {
            text-align: center;
        }
    }

}
</style>
